import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {throwError as observableThrowError,  Observable, of as observableOf } from 'rxjs';
import { catchError, map } from "rxjs/operators";
import { HttpParams } from '@angular/common/http';
import { IPromotions } from '../interfaces/promotions';
import { IPromotion } from '../interfaces/promotion';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  constructor(private _apiService: ApiService) { }

  search(arr: any) : Observable<IPromotions>  {
    let urlParams = new HttpParams()
    for(let i in arr) {
      urlParams = urlParams.set(i, arr[i].toString())
    }

    //urlParams = urlParams.set('sort', sort)
    //urlParams = urlParams.set('direction', direction)
    //urlParams = urlParams.set('page', page.toString())

    return this._apiService.doGET('promotions', urlParams)
      .pipe(catchError(err => {
      return observableThrowError(err.error_message)
    }))
  }

  show(id: number) : Observable<IPromotion>  {
    return this._apiService.doGET('promotion/'+id)
      .pipe(catchError(err => {
      return observableThrowError(err.error_message)
    }))
  }

  store(data) : Observable<any> {
    return this._apiService.doPOST('promotions', data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  patch(idpromocao, data) : Observable<any> {
    return this._apiService.doPATCH('promotion/'+idpromocao, data)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  delete(idpromocao) : Observable<any> {
    return this._apiService.doDELETE('promotion/'+idpromocao)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }

  removeSelo(idpromotion, selo) : Observable<any> {
    return this._apiService.doDELETE('promotion/'+idpromotion+'/selo/'+selo)
    .pipe(catchError(err => {
      return observableOf([])
    }))
  }
}
